import React from "react";
import { useMessageSource } from "react-message-source";
import { ApplicationFlows } from "../../route/application/authenticated/application-flow/types";
import RadioButtonContainer from "../../ui/layout/page/forms-container/form-item-container/radio-button-container/input-container";
import { mapPersonSameAsToEvent } from "../../util/tracking/eventActionMapper";
import GTM from "../../util/tracking/gtm";
import { EventCategory } from "../../util/tracking/types";
import ChoosePerson from "../shared/components/choose-person";

interface SameAsCardholderRadioProps {
  isSameAsCardholder: "yes" | "no";
  gender: string;
  firstName: string;
  lastName: string;
  flowType: ApplicationFlows;
}

export default function SameAsCardholderRadio({
  isSameAsCardholder,
  gender,
  firstName,
  lastName,
  flowType,
}: SameAsCardholderRadioProps): React.JSX.Element {
  const cardholder = {
    gender,
    firstName,
    lastName,
  };

  const { getMessage } = useMessageSource();

  return (
    <RadioButtonContainer>
      <ChoosePerson
        title={
          flowType === ApplicationFlows.ADDITIONAL_CA
            ? getMessage("Signing.subtitle-description-variation-2")
            : getMessage("Signing.subtitle-description-variation-1")
        }
        subTitle={
          isSameAsCardholder === "no"
            ? getMessage("Signing.subtitle-first-signing")
            : null
        }
        id="isSameAsCardholder"
        name="isSameAsCardholder"
        values={[
          {
            id: "isSameAsCardholder-yes",
            value: "yes",
            messageKey: "Signing.SAME_AS_CARDHOLDER",
            person: cardholder,
          },
          {
            id: "isSameAsCardholder-no",
            value: "no",
            messageKey: "Signing.OTHER",
          },
        ]}
        onChange={(_, newValue) => {
          GTM.trackEvent(
            EventCategory.AuthorizedSignatory,
            mapPersonSameAsToEvent(newValue === "yes"),
          );
        }}
      />
    </RadioButtonContainer>
  );
}
